import { isPlatform } from "@ionic/react"
import Api from "../services/Api"
import { PedoListenerApp } from "../plugins/PedoListener"
import { AndroidPermissions } from "@awesome-cordova-plugins/android-permissions"
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';

const api = Api.getInstance()
const ACTIVITY_PERMISSION = "android.permission.ACTIVITY_RECOGNITION"

export const resumeApp = () => {
  // console.log('Resume app Step counter')
  updateStepData()
}

export const enabledInt = (enabled: boolean) => {
  const enabledInt = enabled ? 1 : 0
  api.get('pedometer/on_off/' + enabledInt).then(res => {
    res.json().then(data => {
      if(data.status === 'ok') {
        // console.log('enabled: ' + data.enabled)
      } else {
        // console.error('enabled failed, status not ok')
      }
    }).catch(e => {
        console.error('enabled failed', e)
      }
    )
  }).catch(e => {
    console.error('api call for on_off failed')
  })
}

export const requestStepPermission = async () => {
  return new Promise((resolve, reject) => {
    AndroidPermissions.requestPermission(ACTIVITY_PERMISSION).then(res => {
      if(res.hasPermission){
        console.log('has activity permission', res)
        // doEnableSteps('stepsStart')
        // enabledInt(true)
        resolve(true)
      } else {
        // doEnableSteps('stepsStop')
        // enabledInt(false)
        reject()
        console.log('Permission denied by you 1')
      }
    },
    err => {
      doEnableSteps('stepsStop')
      enabledInt(false)
      reject()
      // console.error(err)
    }
  )
  })
}

export const checkStepcounterEnabled = async () => {
  // 1
  return new Promise((resolve, reject) => {
    if(isPlatform('capacitor')) {
      if(isPlatform('android')) {
        AndroidPermissions.checkPermission(ACTIVITY_PERMISSION).then(res => {
          if(res.hasPermission) {
            getStepSettings()
            doEnableSteps('stepsStart')
            enabledInt(true)
            resolve(true)
          } else {
            requestStepPermission().then(res => {
              if(res === true) {
                doEnableSteps('stepsStart')
                enabledInt(true)
                getStepSettings()
                resolve(true)
              } else {
                doEnableSteps('stepsStop')
                enabledInt(false)
                reject()
              }
            }).catch(e => {
              reject()
              doEnableSteps('stepsStop')
            })
          }
        }).catch(e => {
          doEnableSteps('stepsStop')
        })
    
      } else {
        //ios
        getStepSettings()
        resolve(true)
      } 
    } else {
      getStepSettings()
      resolve(true)

      //desktop
    }
  })
}

export const doEnableSteps = (command: string) => {
  PedoListenerApp.pedoCommand({cmd: command}).then(res => {
    const stepsEnabled = res.response === "true"
    if(stepsEnabled){
      updateStepData()
    }
  })
}

export const getStepSettings = () => {
  // 2
  if (isPlatform('capacitor')) {
    PedoListenerApp.pedoCommand({cmd: "stepsIsStarted"}).then(res => {
      const stepsEnabled = res.response === "true"
      if (stepsEnabled) {
        updateStepData()
      }
    })
  } else {
    // this.setState({stepsEnabled: false})
  }
}

export const updateStepData = async () => {
  return new Promise((resolve, reject) => {
    let stepsPerDay = {}
    if(isPlatform('capacitor')) {
      PedoListenerApp.pedoCommand({cmd: "stepsAll"}).then(res => {
        stepsPerDay = JSON.parse(res.response)
        syncSteps(stepsPerDay).then(res => res === true ? resolve(true) : reject())
      })
    } else {
      syncSteps(stepsPerDay).then(res => res === true ? resolve(true) : reject())
    }
  })
}

export const syncSteps = async (stepsPerDay: any) => {
  return new Promise((resolve, reject) => {
    api.post('pedometer/sync', stepsPerDay).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          // stepsPerDay = data.stepsPerDay
          resolve(true)
        } else {
          reject()
          // console.error('syncSteps failed, status not ok')
        }
      }).catch(e => {
          reject()
          // console.error('sync_steps failed', e)
        }
      )
    }).catch(e => {
      reject()
      // console.error('api call for syncSteps failed')
    })
  })
}

export const openSettings = async () => {
  if (isPlatform('ios')) {
    doEnableSteps('stepsStop')
    enabledInt(false)
    await NativeSettings.openIOS({
      option: IOSSettings.App,
    });
  } else if(isPlatform('android')){
      doEnableSteps('stepsStop')
      enabledInt(false)
      await NativeSettings.openAndroid({
      option: AndroidSettings.ApplicationDetails,
    });
  } else {
    return true
  }
}